module.exports = __webpack_public_path__ + "img/icon-arrow-ascending.8dcfb0f8.svg";